import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomCatchCopy = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();

	const { catchCopy } = viewModel;

	const onSetMainTarget = useCallback(
		(input: string) => {
			const value = !catchCopy ? { isEdited: true, value: input } : { ...catchCopy, value: input };

			onSetViewModel([{ key: "catchCopy", value }]);
		},
		[catchCopy, onSetViewModel],
	);

	return {
		catchCopy,
		onSetMainTarget,
	};
};
